<h2 mat-dialog-title align="center">{{product.name}}({{product.unit_type}})</h2>
<mat-dialog-content>
  <form [formGroup]="receiveForm">
    <table>
      <tr>
        <td>
          <mat-form-field appearance="fill">
            <mat-label>ราคาต้นทุน</mat-label>
            <input matInput type="number" formControlName="cost" required>
          </mat-form-field>
        </td>
        <td>
          <mat-form-field appearance="fill">
            <mat-label>ราคาขายส่ง</mat-label>
            <input matInput formControlName="wholesale_price">
          </mat-form-field>
        </td>
        <td>
          <mat-form-field appearance="fill">
            <mat-label>ราคาหน้าร้าน</mat-label>
            <input matInput formControlName="front_store_price">
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td>
          <mat-form-field appearance="fill">
            <mat-label>จำนวนที่ได้รับ</mat-label>
            <input matInput type="number" formControlName="quantity" required>
          </mat-form-field>
        </td>
      </tr>
    </table>
  </form>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close="false">ปิด</button>
  <button mat-button [disabled]="!receiveForm.valid" (click)="save()">บันทึก</button>
</div>